module.exports = __webpack_public_path__ + "static/media/rules-banner.970a10be.png";